import Phaser from 'phaser';

/**
 * Re-bake a loaded image texture with near-white pixels stripped to alpha 0,
 * so AI-generated sprite PNGs (which have white backgrounds) blend cleanly.
 *
 * Tolerance is generous (235+) because the upscaled sprites have anti-aliased
 * white edges that read as light grey.
 */
export function chromaKeyTextures(scene: Phaser.Scene, keys: string[], tolerance = 235): void {
  for (const key of keys) {
    const tex = scene.textures.get(key);
    if (!tex || !tex.source[0]) continue;

    const src = tex.getSourceImage(0) as HTMLImageElement | HTMLCanvasElement;
    if (!src) continue;

    const w = (src as HTMLImageElement).width;
    const h = (src as HTMLImageElement).height;
    const canvas = document.createElement('canvas');
    canvas.width = w;
    canvas.height = h;
    const ctx = canvas.getContext('2d');
    if (!ctx) continue;

    ctx.drawImage(src as CanvasImageSource, 0, 0);
    const imgData = ctx.getImageData(0, 0, w, h);
    const data = imgData.data;
    for (let i = 0; i < data.length; i += 4) {
      const r = data[i];
      const g = data[i + 1];
      const b = data[i + 2];
      if (r >= tolerance && g >= tolerance && b >= tolerance) {
        data[i + 3] = 0;
      } else if (r >= 210 && g >= 210 && b >= 210) {
        // Soften the AA halo a touch.
        data[i + 3] = Math.min(data[i + 3], 100);
      }
    }
    ctx.putImageData(imgData, 0, 0);

    scene.textures.remove(key);
    scene.textures.addCanvas(key, canvas);
  }
}
